/**
 * Labstep
 *
 * @module core/DangerousDiv
 * @desc Div with sanitized html
 */

import dompurify from 'dompurify';
import type React from 'react';
import type { IDangerousDiv } from './types';

/**
 * Core DangerousDiv component
 */
export const DangerousDiv: React.FC<IDangerousDiv> = ({
  html,
  className,
  style = {},
  domPurifyParams = {},
  id,
  ...rest
}) => (
  <div
    id={id}
    className={className}
    style={style}
    dangerouslySetInnerHTML={{
      __html: dompurify.sanitize(
        html,
        domPurifyParams,
      ) as unknown as string,
    }}
    {...rest}
  />
);
